import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';

import {RootState} from '@/app/store';
import {EReducersPath} from '@/dataSource/utils/ReducerPaths';

import {setBearerTokenIfExists, setWafHeaders} from '../headers';
import {reAuth} from '../reAuth';

import {apiBaseCards} from './constants';
import {ICardThemesResponse, ICardThemesV2Response} from './entities';

const baseQuery = async (baseUrl: string) =>
  fetchBaseQuery({
    baseUrl,
    timeout: 30 * 1000,
    prepareHeaders: async (headers, {getState}) => {
      const token = (getState() as RootState).tokenDataSlice?.tokenData
        ?.accessToken;
      setBearerTokenIfExists(headers, token);
      await setWafHeaders(baseUrl, headers);
      return headers;
    },
  });

const baseApiQueryWithReAuth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const baseUrl = apiBaseCards.baseUrl;

  const result = await reAuth(args, api, extraOptions, baseUrl, baseQuery);
  return result;
};

export const cardsThemeApi = createApi({
  reducerPath: EReducersPath.CARDS_THEME_API,
  refetchOnReconnect: true,
  baseQuery: baseApiQueryWithReAuth,
  endpoints: build => ({
    getCardThemes: build.query<ICardThemesResponse, void>({
      query: () => apiBaseCards.endpoints.getCardThemes,
    }),
    getCardThemesV2: build.query<ICardThemesV2Response[], void>({
      query: () => apiBaseCards.endpoints.getCardThemesV2,
    }),
  }),
});

export const {useGetCardThemesQuery, useLazyGetCardThemesV2Query} =
  cardsThemeApi;
